module.exports = __webpack_public_path__ + "img/SketchPngd4ae08396488838841ae9db601a3025336d5cde38753b55a5e38d22c31386b51.3bded8b9.png";